var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGDriveKbFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.71454 14.7929C2.80141 14.9112 2.91486 15.0076 3.04576 15.0741C3.17665 15.1406 3.32134 15.1755 3.46817 15.1759H14.8762C15.0361 15.1753 15.1933 15.134 15.3328 15.0557C15.4722 14.9774 15.5895 14.8649 15.6733 14.7287L17.3648 11.9502C17.4533 11.804 17.5 11.6365 17.5 11.4657C17.5 11.2949 17.4533 11.1274 17.3648 10.9812L11.4538 1.27096C11.3697 1.13358 11.2516 1.02024 11.1108 0.941896C10.9701 0.86355 10.8115 0.822854 10.6505 0.823745H7.33779C7.17812 0.824274 7.02125 0.865645 6.88209 0.943923C6.74293 1.0222 6.62611 1.13478 6.54275 1.27096L0.63584 10.9605C0.540065 11.1181 0.493085 11.3005 0.500823 11.4847C0.50856 11.6689 0.570669 11.8467 0.679318 11.9957L2.71454 14.7929ZM14.8182 14.1407H3.65037L4.96302 11.9833H16.1433L14.8182 14.1407ZM12.3938 10.9481H5.59449L8.99412 5.3621L12.3938 10.9481ZM16.1329 10.9481H13.607L8.07486 1.85895H10.6008L16.1329 10.9481ZM7.13075 2.2896L8.3937 4.36002L2.93194 13.3312L1.55718 11.4409L7.13075 2.2896Z",
    fill: "#047857"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGDriveKbFile);
export default __webpack_public_path__ + "static/media/g_drive_kb_file.bcb6a934a2f670d504c6a33edabb2e26.svg";
export { ForwardRef as ReactComponent };